import {useMutation} from '@apollo/client';
import {CREATE_PRODUCT} from "../productTypeDefs";

export const useMutationCreateProduct = (options?: any): any => (
  useMutation(CREATE_PRODUCT, options)
);
